import { RootState } from "@/lib/store";
import { setSettings } from "@/lib/store/theme/actions";
import { CookiesKey } from "@starsoft/common/enums";
import { Nullable } from "@starsoft/common/interfaces";
import {
  CoinEntity,
  GamingAggregatorEntity,
  GamingAggregatorIdEnum,
  GamingAggregatorStatusIdEnum,
  OperatorDto,
  OriginEntity,
  OriginIdEnum,
  OriginRedirectMappingEntity,
  Setting,
} from "@starsoft/common/models";
import { setCookie } from "cookies-next";
import { useCallback, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

export function useResolvedSettings(setting?: Setting) {
  const dispatch = useDispatch();
  const stateSetting = useSelector((state: RootState) => state.theme.setting);

  const origin: Nullable<OriginEntity> = useMemo(() => {
    //@ts-ignore
    return setting?.settings?.origin || stateSetting?.settings?.origin;
  }, [setting, stateSetting]);

  const originId: Nullable<OriginIdEnum> = useMemo(() => {
    return origin?.id;
  }, [origin]);

  const aggregators: Array<GamingAggregatorEntity> = useMemo(() => {
    return (
      //@ts-ignore
      setting?.settings?.aggregators || stateSetting?.settings?.aggregators
    );
  }, [setting, stateSetting]);

  const operator: Nullable<OperatorDto> = useMemo(() => {
    //@ts-ignore
    return setting?.settings?.operator || stateSetting?.settings?.operator;
  }, [setting, stateSetting]);

  const redirects: Array<OriginRedirectMappingEntity> = useMemo(() => {
    return (
      //@ts-ignore
      setting?.settings?.origin?.redirects ||
      //@ts-ignore
      stateSetting?.settings?.origin?.redirects
    );
  }, [setting, stateSetting]);

  const handleInitStateSetting = useCallback(() => {
    setCookie(CookiesKey.OriginId, originId?.toString() ?? "", {
      sameSite: "strict",
    });
    if (!setting) {
      return;
    }

    dispatch(setSettings(setting));
  }, [setting, dispatch, originId]);

  const systemCoin: Nullable<CoinEntity> = useMemo(() => {
    //@ts-ignore
    return setting?.settings?.coin || stateSetting?.settings?.coin;
  }, [setting, stateSetting]);

  const systemSportsbook: Nullable<GamingAggregatorEntity> = useMemo(() => {
    //@ts-ignore
    return setting?.settings?.sportsbook || stateSetting?.settings?.sportsbook;
  }, [setting, stateSetting]);

  const isStarsoftActive = useMemo(() => {
    return (
      aggregators
        ?.find(
          (aggregator) =>
            aggregator.id?.toString() ===
            GamingAggregatorIdEnum.Starsoft?.toString(),
        )
        ?.status?.id?.toString() ===
      GamingAggregatorStatusIdEnum.Active?.toString()
    );
  }, [aggregators]);

  const isSportsbookActive = useMemo(() => {
    return (
      aggregators
        ?.find(
          (aggregator) =>
            aggregator.id?.toString() ===
            GamingAggregatorIdEnum.First?.toString(),
        )
        ?.statusId?.toString() ===
      GamingAggregatorStatusIdEnum.Active?.toString()
    );
  }, [aggregators, stateSetting]);

  useEffect(handleInitStateSetting, [handleInitStateSetting]);

  return {
    setting: setting ?? stateSetting,
    origin,
    originId,
    aggregators,
    systemCoin,
    systemSportsbook,
    isStarsoftActive,
    redirects,
    // operator,
    isSportsbookActive,
  };
}
